export default __webpack_public_path__ + "img/9cc0c24b283cec4d56305a5a11cb3f45.png";